import axios from 'axios';
var api = axios.create();
export var BASE_URL = window.location.protocol + "//" + window.location.host + (process.env.PUBLIC_URL || '');
api.defaults.baseURL = BASE_URL;
api.defaults.withCredentials = true;
export default api;



//////////////////
// WEBPACK FOOTER
// ./src/api.ts
// module id = 22
// module chunks = 0